import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { trackPageView } from './services/analytics';

import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VisitorRegistrationPage from './pages/VisitorRegistrationPage';
import VisitorQRScannerPage from './pages/VisitorQRScannerPage';
import InviteAcceptPage from './pages/InviteAcceptPage';
import AdminPage from './pages/AdminPage';
import SuperAdminPage from './pages/SuperAdminPage';
import QRCodeDemo from './pages/QRCodeDemo';
import DashboardLayout from './components/DashboardLayout';
import ProtectedRoute from './components/ProtectedRoute';

// Dashboard views
import OverviewView from './components/dashboard/OverviewView';
import FlowsView from './components/dashboard/FlowsView';
import AttractionsView from './components/dashboard/AttractionsView';
import PoiManagementView from './components/dashboard/PoiManagementView';
import AnalyticsView from './components/dashboard/AnalyticsView';
import DataSourcesView from './components/dashboard/DataSourcesView';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000,
      gcTime: 300000,
      retry: 2,
    },
  },
});

// Component to track page views
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
}

function AppRoutes() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <PageTracker />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/registrati" element={<RegisterPage />} />
          <Route path="/visitor-registration" element={<VisitorRegistrationPage />} />
          <Route path="/visitor-scanner" element={<VisitorQRScannerPage />} />
          <Route path="/invite-accept" element={<InviteAcceptPage />} />
          <Route path="/qr-demo" element={<QRCodeDemo />} />

          <Route element={<ProtectedRoute />}>
            <Route element={<DashboardLayout />}>
              <Route path="/" element={<Navigate to="/dashboard/overview" replace />} />
              <Route path="/superadmin" element={<SuperAdminPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/dashboard/overview" element={<OverviewView />} />
              <Route path="/dashboard/flows" element={<FlowsView />} />
              <Route path="/dashboard/attractions" element={<AttractionsView />} />
              <Route path="/dashboard/pois" element={<PoiManagementView />} />
              <Route path="/dashboard/analytics" element={<AnalyticsView />} />
              <Route path="/dashboard/data-sources" element={<DataSourcesView />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppRoutes />
    </QueryClientProvider>
  );
}

export default App;
